import React from "react"

export default function TypeConditionalTextAreaRich({ value, description }) {
  return (
    <div>
      <label>{description} </label>
      {value}{" "}
    </div>
  )
}
